import { combineReducers } from '@reduxjs/toolkit'
import { AuthenticationReducer } from 'shared/redux/authentication/authenticationSlice'
import { CorporateProfileReducer } from './CorporateProfile/CorporateProfileSlice'
import { CorporateReducer } from './corporateService'
import { InvoiceInfoReducer } from './CorporateInvoice/CorporateInvoice'
import { BillingReducer } from './CorporateInvoice/CorporateBillingInfo'
import { CorporateCodeServiceReducer } from './corporateCodeService'
import { BrokerServiceReducer } from './brokerService'
import { corporateEmailTemplateServiceReducer } from './emailTemplateService'
import { RecordTypeReducer } from './RecordTypes/RecordTypeSlice';

const appReducer = combineReducers({
  authentication: AuthenticationReducer,
  corporateProfile: CorporateProfileReducer,
  invoiceInfo: InvoiceInfoReducer,
  corporateService: CorporateReducer,
  corporateCodeService: CorporateCodeServiceReducer,
  corporateEmailTemplateService: corporateEmailTemplateServiceReducer,
  brokerService: BrokerServiceReducer,
  recordType: RecordTypeReducer,
  corporateBilling: BillingReducer,
})

export const RootReducer: typeof appReducer = (state, action) => {
  if (action.type === 'USER_LOGOUT') {
    return appReducer(undefined, action)
  }

  return appReducer(state, action)
}
